import { render } from "./TreeView.vue?vue&type=template&id=2585f3a8&scoped=true&ts=true"
import script from "./TreeView.vue?vue&type=script&lang=ts"
export * from "./TreeView.vue?vue&type=script&lang=ts"

import "./tree-view.scss?vue&type=style&index=0&id=2585f3a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2585f3a8"]])

export default __exports__